import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { debounceTime, distinctUntilChanged, fromEvent, map } from "rxjs";

@Component({
  selector: "app-filter-product",
  templateUrl: "./filter-product.component.html",
  styleUrls: ["./filter-product.component.scss"],
  imports: [UiKitModule],
  standalone: true,
})
export class FilterProductComponent implements AfterViewInit {
  @ViewChild("searchField")
  searchField!: ElementRef;
  @Output() searchEvent = new EventEmitter<string>();

  ngAfterViewInit(): void {
    fromEvent(this.searchField.nativeElement, "input")
      .pipe(
        debounceTime(500),
        map(() => (this.searchField.nativeElement.value as string).trim()),
        distinctUntilChanged(),
      )
      .subscribe((value) => {
        this.searchEvent.emit(value);
      });
  }
}
